export class EnvironmentService {
    public production;
    public serverApiUrl;
    public authServerApiUrl;
}
